import { WorkspaceAccessRole } from '../types/WorkspaceAccess';

/**
 * Whether the current user can invite others to the space.
 * Public spaces: anyone can invite.
 * Private spaces: only Owners can invite.
 */
export function canInviteUsers(
  visibility: string | undefined,
  currentUserRole: WorkspaceAccessRole | undefined
): boolean {
  if (visibility === 'public') return true;
  if (visibility === 'private' && currentUserRole === WorkspaceAccessRole.Owner) return true;
  return false;
}

/**
 * Whether the "Claim Ownership" banner should be shown.
 * True when the space has no Owner at all.
 */
export function shouldShowClaimOwnership(
  users: Array<{ role: string }> | undefined
): boolean {
  if (!users) return false;
  return users.find((u) => u.role === WorkspaceAccessRole.Owner) === undefined;
}

/**
 * Whether the current user can change other users' roles.
 * Only Owners can manage roles.
 */
export function canManageRoles(
  currentUserRole: WorkspaceAccessRole | undefined
): boolean {
  return currentUserRole === WorkspaceAccessRole.Owner;
}
